const forms = {
  onRequest: "Su richiesta", // translated
  person: "persona", // translated
  travelDate: "Data di viaggio", // translated
  cancel: "Annulla", // translated
  getPrice: "Ottieni prezzo", // translated
  travelDates: "Date di viaggio", // translated
};


export default forms;
